import React from 'react';
export function HeaderBanner() {
  return <div className="w-full py-12 md:py-16 relative overflow-hidden" style={{
    backgroundColor: '#1e3d2f'
  }} data-id="element-250">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#c8a84b 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-251" />
      <div className="max-w-6xl mx-auto px-4 md:px-8 relative z-10 text-center" data-id="element-252">
        <h1 className="text-4xl md:text-5xl font-bold uppercase tracking-wide text-white mb-4" style={{
        fontFamily: 'Oswald, sans-serif',
        textShadow: '0 2px 4px rgba(0,0,0,0.3)'
      }} data-id="element-253">
          Club Activities
        </h1>
        <p className="text-lg md:text-xl max-w-2xl mx-auto" style={{
        color: '#e8e4d8',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-254">
          From competitive shooting sports to archery and youth programs, FLSC
          offers something for every sportsman.
        </p>
      </div>
    </div>;
}